import { useCallback, useEffect, useState } from "react";
import FocusLock from "react-focus-lock";
import { TfaMethod } from "@/core/constants/tfaMethod";
import { ValidateCode } from "@/shared/ui";
import useChangePassword from "@/domains/playerMenu/hooks/useChangePassword";
import useGetCodeTimer from "@/domains/playerMenu/hooks/useGetCodeTimer";

type Props = {
  address: string;
  goToChangePassword: () => void;
};

export default function PlayerMenuSettingsSafetyChangePasswordSMSCheckContainer({
  goToChangePassword,
  address,
}: Props) {
  const [code, setCode] = useState<string>("");
  const {
    sendCodeHandler,
    sendIsPending,
    sendError,
    checkCodeHandler,
    checkIsCompleted,
    checkIsPending,
    checkError,
  } = useChangePassword();

  const { getTimer, timer } = useGetCodeTimer();

  useEffect(() => {
    getTimer({ type: "sms", payload: address });
  }, []);

  const onSubmit = useCallback(async () => {
    checkCodeHandler(code);
  }, [code]);

  const onSendCodeHandler = useCallback(async () => {
    await sendCodeHandler(address, TfaMethod.SMS);
    await getTimer({ type: "sms", payload: address });
  }, [address]);

  useEffect(() => {
    if (checkIsCompleted) {
      goToChangePassword();
    }
  }, [checkIsCompleted, goToChangePassword]);

  return (
    <FocusLock className="contents">
      <ValidateCode
        address={address}
        type={TfaMethod.SMS}
        code={code}
        onCodeChange={setCode}
        onSubmit={onSubmit}
        onSendCode={onSendCodeHandler}
        pending={checkIsPending}
        error={checkError || sendError}
        sendCodePending={sendIsPending}
        timer={timer}
      />
    </FocusLock>
  );
}
